/* eslint-disable @typescript-eslint/naming-convention */
// TODO : Hide this from non-admin clients (move to admin module?)
// as it reveals a bit of internal information
export enum LicensesEnum {
    CRITICAL_MENTION = 1,
    NLA_PRINT = 2,
    NLA_ECLIPS = 3,
    POST_MEDIA = 4,
    PRECISE = 5,
    ACQUIRE = 6,
    MOREOVER = 7,
    TWITTER = 8,
    FACEBOOK = 10,
    CLA_ONLINE = 11,
    CLA_PRINT = 12,
    MANUALLY_CREATED = 13,
    INSTAGRAM = 14,
    YOUTUBE = 15,
    IPCB = 16,
    LEXISNEXIS = 17,
    REDDIT = 18,
    FACTIVA = 19,
    MELTWATER = 20,
    CEDROM = 21,
    BURELLES_LUCE = 22,
    NEXIS = 23,
    NEWSDESK = 24,
    MAGAZINE = 25,
    TVEYES = 26,
    PODCASTS = 27,
    SNAPSHOT = 28,
    TIKTOK = 29,
    FINANCIAL_TIMES = 30,
    CSV = 35,
    XCAGO = 36,
    FINANCIAL_PODCASTS = 37,
    SMART_PROXY = 38,
    LINKEDIN = 39,
    REFMEDIA = 40,
    BLUESKY = 41,
    CS_IMPORT = 34,
}

export const SocialLicenses = [
    LicensesEnum.FACEBOOK,
    LicensesEnum.TWITTER,
    LicensesEnum.INSTAGRAM,
    LicensesEnum.TIKTOK,
    LicensesEnum.YOUTUBE,
    LicensesEnum.REDDIT,
    LicensesEnum.LINKEDIN,
    LicensesEnum.BLUESKY
];
